import { useQuery } from 'react-query'
import hooks from '../../hooks'
import moment from 'moment'

const emptyArray = [];

const useCourses = ({
    filters: inputFilters = {},
    offset = 0,
    limit = 50,
    enabled = true
} = {}) => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url } = hooks.useApi()
    const dateFormatter = date => date ? moment(date).format('MM/DD/YYYY') : undefined
    const filters = {
        limit,
        offset,
        n: inputFilters.name,
        sd: dateFormatter(inputFilters.startDate),
        ed: dateFormatter(inputFilters.endDate),
        f: inputFilters.facilitator,
        d: inputFilters.dimensions,
        l: inputFilters.locations,
        h: inputFilters.hours,
        gradeLevel: inputFilters.gradeLevel,

    }

    const {
        data,
        isLoading,
        isFetching
    } = useQuery(
        [cacheKeys.COURSES, 'SEARCH', filters],
        () => api.get(url(endpoints.courses, {}, filters)),
        { enabled }
    )

    const courses = data ? data.items : emptyArray

    return {
        isBusy: isLoading || isFetching,
        courses,
        total: data ? data.total : 0,
    }
}

export default useCourses